import { defineComponent as _defineComponent } from 'vue';
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-cf3e856e"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "two_column_images" };
const _hoisted_2 = { class: "container inner" };
const _hoisted_3 = { class: "row" };
const _hoisted_4 = { class: "col-lg-6" };
const _hoisted_5 = ["src", "alt"];
const _hoisted_6 = { class: "mt-3" };
const _hoisted_7 = { class: "col-lg-6" };
const _hoisted_8 = ["src", "alt"];
const _hoisted_9 = { class: "mt-3" };
export default /*#__PURE__*/ _defineComponent({
    __name: 'two_column_images',
    props: ['d'],
    setup(__props) {
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("div", _hoisted_3, [
                        _createElementVNode("div", _hoisted_4, [
                            _createElementVNode("img", {
                                src: __props.d.image_one,
                                alt: __props.d.caption_one,
                                class: "img-fluid",
                                loading: "lazy"
                            }, null, 8, _hoisted_5),
                            _createElementVNode("p", _hoisted_6, _toDisplayString(__props.d.caption_one), 1)
                        ]),
                        _createElementVNode("div", _hoisted_7, [
                            _createElementVNode("img", {
                                src: __props.d.image_two,
                                alt: __props.d.caption_two,
                                class: "img-fluid",
                                loading: "lazy"
                            }, null, 8, _hoisted_8),
                            _createElementVNode("p", _hoisted_9, _toDisplayString(__props.d.caption_two), 1)
                        ])
                    ])
                ])
            ]));
        };
    }
});
